type SerializableError = string | null | undefined | {
  message?: string;
  name?: string;
  stack?: string;
  response?: Record<string, unknown>;
  request?: Record<string, unknown>;
  code?: string | number;
  status?: number;
  statusCode?: number;
};

export const serializeError = (error: SerializableError) => {
  // If it's already a string, return as is
  if (typeof error === 'string') {
    return error;
  }

  // If it's null or undefined, return a default error message
  if (error == null) {
    return {
      message: 'Unknown error',
      name: 'Error',
    };
  }

  // Convert error object to plain object
  return {
    message: error?.message || 'Unknown error',
    name: error?.name || 'Error',
    stack: error?.stack,
    ...(error?.response && { response: error.response }),
    ...(error?.request && { request: error.request }),
    ...(error?.code && { code: error.code }),
    ...(error?.status && { status: error.status }),
    ...(error?.statusCode && { statusCode: error.statusCode }),
  };
};
